module.exports = "<span>{{ $ctrl.name }}</span> ";